import * as React from "react";
import type { SVGProps } from "react";
const SvgCaretUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={6}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillRule="evenodd"
      d="M5.003.393a.703.703 0 0 1 .994 0l4.219 4.22a.703.703 0 1 1-.994.994L5.5 1.885 1.778 5.607a.703.703 0 1 1-.994-.995z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCaretUp;
